/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommentSearchView } from './commentSearchView';
import { CommunityBasic } from './communityBasic';
import { DeletedSearchItem } from './deletedSearchItem';
import { FullUser } from './fullUser';
import { PostBasic } from './postBasic';
import { ProjectBasic } from './projectBasic';

export interface SearchResult { 
    entity_kind: string;
    view_type: string;
    score?: number;
    /**
     * Map: field name -> list of highlighted fragments for that field. Keys are field names (e.g., \"title\", \"body\"). 
     */
    highlight?: { [key: string]: Array<string>; };
    item: DeletedSearchItem | ProjectBasic | CommunityBasic | FullUser | PostBasic | CommentSearchView;
}